import React from 'react';
import ToggleShortcut from './ToggleShortcut';
import {
  getUserFile,
  requestTenantAsset,
} from '../../../store/current-user/CurrentUserActions';
import { connect } from 'react-redux';

class LoginInfo extends React.Component {
  constructor() {
    super();
    this.state = {
      fileName: null,
      fileType: null,
      asset: null,
    };
  }

  componentDidMount() {
    if (this.props.user.data.photo != null) {
      this.previewFile(this.props.user.data.photo);
    }
    const { tenantId } = this.props.user.queryParams;
    this.getTenantAsset({ tenantId: tenantId });
  }

  previewFile(filename) {
    this.props
      .getUserFile(this.props.user.data.id, filename)
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
      });
  }

  getTenantAsset() {
    const { tenantId } = this.props.user.queryParams;
    this.props.getTenantAsset({ tenantId: tenantId }).then((response) => {
      const blob = response.payload;
      try {
        this.setState({ asset: URL.createObjectURL(blob) });
      } catch (ex) {
        console.error(ex);
      }
    });
  }

  render() {
    return (
      <div className="login-info">
        <span>
          <ToggleShortcut>
            <img
              src={
                this.state.fileName == null
                  ? 'assets/img/avatars/sunny.png'
                  : this.state.fileName
              }
              alt="me"
              className="online"
            />
            <span>
              {this.props.user.data &&
                `${this.props.user.data.firstName} ${this.props.user.data.lastName}`}
            </span>
            <i className="fa fa-angle-down" />
            <link
              id="customCss"
              rel="stylesheet"
              type="text/css"
              media="screen"
              href={this.state.asset}
            />
          </ToggleShortcut>
        </span>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    user: state.currentUser,
  }),
  (dispatch) => ({
    getUserFile: (userId, file) => dispatch(getUserFile(userId, file)),
    getTenantAsset: (params) => dispatch(requestTenantAsset(params)),
  }),
)(LoginInfo);



// WEBPACK FOOTER //
// ./src/components/current-user/components/LoginInfo.js